<template>
  <div>
    <div class="row beast-contributor-add" v-if="isLoggedIn">
      <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
      <div class="col-7">
        <div class="form-group">
          <label>User</label>
          <input type="text" class="form-control" v-model="contributor.username"/>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label>Access</label>
          <select class="form-control" v-model="contributor.access">
            <option v-for="(value, key) in contributorAccess"
                    :value="key"
                    :key="key">
              {{value}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group text-center">
          <label>&nbsp;</label>
          <div class="btn-group btn-block">
            <button class="btn btn-success" @click="storeData">
              <font-awesome-icon :icon="save"/>
            </button>
            <button class="btn btn-danger" @click="clearData">
              <font-awesome-icon :icon="times"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-striped table-borderless beast-table" v-if="contributors.length">
      <thead>
      <tr>
        <th class="beast-table-name">Name</th>
        <th class="beast-table-access" v-if="isLoggedIn">Access</th>
        <th class="beast-table-edit" v-if="isLoggedIn">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="contributor.fullName"
          v-for="contributor in contributors">

        <td class="beast-table-name">
          <router-link :to="`/profile/${contributor.profile}`">
            {{contributor.fullName}} ({{contributor.profile}})
          </router-link>
        </td>
        <td class="beast-table-access" v-if="isLoggedIn">
          {{contributor.access}}
        </td>
        <td class="beast-table-edit" v-if="isLoggedIn">
          <div class="btn-group" v-if="contributor.access !== 'OWNER'">
            <button class="btn btn-link text-warning" @click="modify(contributor.profile, contributor.access)">
              <font-awesome-icon :icon="edit"/>
            </button>
            <button class="btn btn-link text-danger" @click="remove(contributor.profile)">
              <font-awesome-icon :icon="times"/>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <h4 v-else> There are no contributors for this package! </h4>
  </div>
</template>


<style scoped lang="scss">
  .beast-table {
    .beast-table-name {
      width: 70%;
      vertical-align: middle;
      a {
        color: $beast-dark-gray;

        &:hover {
          color: $beast-green
        }
      }
    }
    .beast-table-access {
      width: 30%;
      vertical-align: middle;
    }
  }

  .beast-contributor-add {
    label {
      font-weight: bold;
    }
  }
</style>

<script>
import { faSave, faEdit, faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";

export default {
  props: {
    pkg: Object
  },
  watch: {
    async pkg() {
      await this.readData();
    }
  },
  computed: {
    apiURL() {
      return `/packages/${this.pkg.name}/contributors`;
    },
    isLoggedIn() {
      return this.$auth.check() && this.pkg && this.pkg.allowedToEdit;
    },
    edit() {
      return faEdit;
    },
    times() {
      return faTimes;
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      contributors: [],
      contributorAccess: [],
      contributor: {
        username: "",
        access: "READ",
        new: true
      },
      save: faPlus
    };
  },
  methods: {
    async readData() {
      const response = await this.axios.get(this.apiURL);
      this.contributors = response.data;

      if (this.$auth.check()) {
        const responseContributorAccess = await this.axios.get(`${this.apiURL}/access`);
        this.contributorAccess = responseContributorAccess.data;
        delete this.contributorAccess.OWNER;
      }
    },
    modify(username, access) {
      this.contributor.username = username;
      this.contributor.access = access;
      this.contributor.new = false;
      this.save = faSave;
    },
    async remove(username) {
      try {
        await this.$dialog.confirm("Are you sure you want to delete the user?", {
          okText: "Yes",
          cancelText: "Cancel"
        });
        await this.axios.delete(this.apiURL, {
          data: {
            username
          }
        });
        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        this.clearData();
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    clearData() {
      this.contributor.username = "";
      this.contributor.access = "USER";
      this.contributor.new = true;
      this.save = faPlus;
    },
    async storeData() {
      const body = Object.assign({}, this.contributor);
      delete body.new;

      try {
        await (this.contributor.new
          ? this.axios.post(this.apiURL, body)
          : this.axios.put(this.apiURL, body));

        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        this.clearData();
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    if (this.pkg.name !== "") {
      await this.readData();
    }
  }
};
</script>
